import { isNumeric } from "./format";

export const isValidAmount = (amount, unit_of_measurement) => {
  const TYPE_UNIT_OF_MEASUREMENT_COMPRIMIDO = "COMPRIMIDO";
  const TYPE_UNIT_OF_MEASUREMENT_DRAGEA = "DRAGEA";
  const TYPE_UNIT_OF_MEASUREMENT_PASTILHA = "PASTILHA";
  const TYPE_UNIT_OF_MEASUREMENT_ML = "ML";

  const TYPE_UNIT_OF_MEASUREMENT_ADESIVO = "ADESIVO";
  const TYPE_UNIT_OF_MEASUREMENT_CAPSULA = "CAPSULA";
  const TYPE_UNIT_OF_MEASUREMENT_DOSE = "DOSE";
  const TYPE_UNIT_OF_MEASUREMENT_ENVELOPE = "ENVELOPE";
  const TYPE_UNIT_OF_MEASUREMENT_FRASCO = "FRASCO";
  const TYPE_UNIT_OF_MEASUREMENT_GRAMA = "GRAMA";
  const TYPE_UNIT_OF_MEASUREMENT_SACHE = "SACHE";
  const TYPE_UNIT_OF_MEASUREMENT_SUPOSITORIO = "SUPOSITORIO";
  const TYPE_UNIT_OF_MEASUREMENT_UNIDADE = "UNIDADE";
  const TYPE_UNIT_OF_MEASUREMENT_UI = "UI";

  const types_unit_of_measurement = {
    ADESIVO: "ADESIVO TRANSDÉRMICO",
    CAPSULA: "CÁPSULA",
    COMPRIMIDO: "COMPRIMIDO",
    DOSE: "DOSE",
    DRAGEA: "DRÁGEA",
    ENVELOPE: "ENVELOPE",
    FRASCO: "FRASCO",
    GRAMA: "GRAMA",
    ML: "ML",
    PASTILHA: "PASTILHA",
    SACHE: "SACHÊ",
    SUPOSITORIO: "SUPOSITORIO",
    UNIDADE: "UNIDADE",
    UI: "UI/ML",
    default: "QUANTIDADE",
  };

  const type_unit_of_measurement =
    types_unit_of_measurement[unit_of_measurement] ||
    types_unit_of_measurement.default;

  const units_of_measurement = [
    "ADESIVO",
    "CAPSULA",
    "COMPRIMIDO",
    "DOSE",
    "DRAGEA",
    "ENVELOPE",
    "FRASCO",
    "GRAMA",
    "ML",
    "PASTILHA",
    "SACHE",
    "SUPOSITORIO",
    "UNIDADE",
    "UI",
  ];

  amount = String(amount).trim();

  let quantity = amount;

  if (!units_of_measurement.includes(unit_of_measurement)) {
    return {
      error: true,
      message: "TIPO DE UNIDADE inválida",
    };
  }

  if (!String(amount).trim()) {
    return {
      error: true,
      message: `Informe ${type_unit_of_measurement}`,
    };
  }

  // Validação

  // COMPRIMIDO || DRAGEA || PASTILHA
  // Verifica se quantidade informada é valida
  if (
    unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_COMPRIMIDO ||
    unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_DRAGEA ||
    unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_PASTILHA
  ) {
    let amount_tmp = String(amount)
      .replace(",", "")
      .replace(".", "");

    if (!String(amount).match(/^[0-9]*[,.]{0,1}[0-9]+$/)) {
      return {
        error: true,
        message: `${type_unit_of_measurement} inválido(a)`,
      };
    }

    if (String(amount_tmp).length > 255) {
      return {
        error: true,
        message: "Informe até 255 caracteres",
      };
    }

    if (parseInt(amount_tmp) <= 0) {
      return {
        error: true,
        message: `Informe ${type_unit_of_measurement} acima de 0`,
      };
    }

    let quantity = String(amount).replace(",", ".");

    let regex = new RegExp(/^[0-9]+$/);
    let onlyNumber = regex.test(String(quantity));

    if (!onlyNumber) {
      if (
        quantity.split(".")[1].length != 2 &&
        quantity.split(".")[1].length != 1
      ) {
        return {
          error: true,
          message: `${type_unit_of_measurement} inválido(a)`,
        };
      }

      if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_COMPRIMIDO) {
        if (
          quantity.split(".")[1] != 25 &&
          quantity.split(".")[1] != 33 &&
          quantity.split(".")[1] != 50 &&
          quantity.split(".")[1] != 5 &&
          quantity.split(".")[1] != 66 &&
          quantity.split(".")[1] != 75
        ) {
          return {
            error: true,
            message: `${type_unit_of_measurement} inválido(a)`,
          };
        }
      } else {
        if (
          quantity.split(".")[1] != 25 &&
          quantity.split(".")[1] != 50 &&
          quantity.split(".")[1] != 5 &&
          quantity.split(".")[1] != 75
        ) {
          return {
            error: true,
            message: `${type_unit_of_measurement} inválido(a)`,
          };
        }
      }

    }
  }

  // ML
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_ML) {
    let amount_tmp = String(amount).replace(",", "").replace(".", "");

    if (!String(amount).match(/^[0-9]*[,.]{0,1}[0-9]+$/)) {
      return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
    }

    if (String(amount_tmp).length > 255) {
      return { error: true, message: "Informe até 255 caracteres", };
    }

    if (parseInt(amount_tmp) <= 0) {
      return { error: true, message: `Informe ${type_unit_of_measurement} acima de 0`, };
    }

    let quantity = String(amount).replace(",", ".");

    let regex = new RegExp(/^[0-9]+$/);
    let onlyNumber = regex.test(String(quantity));

    if (!onlyNumber) {
      if (quantity.split(".")[1].length != 2 && quantity.split(".")[1].length != 1) {
        return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
      }

      if (
        quantity.split(".")[1] != 1 &&
        quantity.split(".")[1] != 2 &&
        quantity.split(".")[1] != 3 &&
        quantity.split(".")[1] != 4 &&
        quantity.split(".")[1] != 5 &&
        quantity.split(".")[1] != 6 &&
        quantity.split(".")[1] != 7 &&
        quantity.split(".")[1] != 8 &&
        quantity.split(".")[1] != 9
      ) {
        return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
      }

    }
  }

  // GRAMA
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_GRAMA) {
    let amount_tmp = String(amount).replace(",", "").replace(".", "");

    if (!String(amount).match(/^[0-9]*[,.]{0,1}[0-9]+$/)) {
      return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
    }

    if (String(amount_tmp).length > 255) {
      return { error: true, message: "Informe até 255 caracteres", };
    }

    if (parseInt(amount_tmp) <= 0) {
      return { error: true, message: `Informe ${type_unit_of_measurement} acima de 0`, };
    }

    let quantity = String(amount).replace(",", ".");

    let regex = new RegExp(/^[0-9]+$/);
    let onlyNumber = regex.test(String(quantity));

    if (!onlyNumber) {
      if (quantity.split(".")[1].length != 2 && quantity.split(".")[1].length != 1) {
        return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
      }

      if (
        quantity.split(".")[1] != 1 &&
        quantity.split(".")[1] != 2 &&
        quantity.split(".")[1] != 3 &&
        quantity.split(".")[1] != 4 &&
        quantity.split(".")[1] != 5 &&
        quantity.split(".")[1] != 6 &&
        quantity.split(".")[1] != 7 &&
        quantity.split(".")[1] != 8 &&
        quantity.split(".")[1] != 9
      ) {
        return { error: true, message: `${type_unit_of_measurement} inválido(a)`, };
      }

    }
  }

  // COMPRIMIDO
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_COMPRIMIDO) {
    quantity = String(amount).replace(",", ".");
  }

  // DRAGEA
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_DRAGEA) {
    quantity = String(amount).replace(",", ".");
  }

  // PASTILHA
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_PASTILHA) {
    quantity = String(amount).replace(",", ".");
  }

  // ML
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_ML) {
    quantity = String(amount).replace(",", ".");
  }

  if (
    unit_of_measurement != TYPE_UNIT_OF_MEASUREMENT_COMPRIMIDO &&
    unit_of_measurement != TYPE_UNIT_OF_MEASUREMENT_DRAGEA &&
    unit_of_measurement != TYPE_UNIT_OF_MEASUREMENT_PASTILHA &&
    unit_of_measurement != TYPE_UNIT_OF_MEASUREMENT_ML &&
    unit_of_measurement != TYPE_UNIT_OF_MEASUREMENT_GRAMA
  ) {
    if (!isNumeric(amount)) {
      return {
        error: true,
        message: `Informe apenas números inteiros no campo ${type_unit_of_measurement}`,
      };
    }

    if (String(amount).length > 255) {
      return {
        error: true,
        message: "Informe até 255 caracteres",
      };
    }

    if (parseInt(amount) <= 0) {
      return {
        error: true,
        message: `Informe ${type_unit_of_measurement} acima de 0`,
      };
    }
  }

  // ADESIVO
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_ADESIVO) {
    quantity = amount;
  }

  // CAPSULA
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_CAPSULA) {
    quantity = amount;
  }

  // DOSE
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_DOSE) {
    quantity = amount;
  }

  // ENVELOPE
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_ENVELOPE) {
    quantity = amount;
  }

  // FRASCO
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_FRASCO) {
    quantity = amount;
  }

  // GRAMA
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_GRAMA) {
    quantity = String(amount).replace(",", ".");
  }

  // SACHE
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_SACHE) {
    quantity = amount;
  }

  // SUPOSITORIO
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_SUPOSITORIO) {
    quantity = amount;
  }

  // UNIDADE
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_UNIDADE) {
    quantity = amount;
  }

  // UI/ML
  if (unit_of_measurement == TYPE_UNIT_OF_MEASUREMENT_UI) {
    quantity = amount;
  }

  return { error: false, quantity: parseFloat(quantity) };
};
